import { IController, IRootScopeService } from 'angular';
import { inject, injectable } from '../../../shared/utils/inject/inject';
import { IHeightCalc } from '../../services/heightCalc/heightCalc.factory';
import { ISchemaService } from '../../services/schemaService/schemaService.factory';
import { IWixApi } from '../../services/wix/wixApi';
import { ISettings, IWixBinding } from '../../services/wix/wixBinding';

@injectable
export class WidgetController implements IController {
  @inject private heightCalc: IHeightCalc;
  @inject private wixBinding: IWixBinding;
  @inject private $rootScope: IRootScopeService;
  @inject private schemaService: ISchemaService;
  @inject private wixApi: IWixApi;
  private ready: boolean;
  private settings: ISettings;
  private height: { widget: null; rows: number };
  private widgetHeight: number;
  private mobile: boolean;

  $onInit() {
    this.wixBinding.initialSettings().then((data) => {
      this.settings = data;
    });
    this.heightCalc.lengthenWidget();

    const heightParams = this.heightCalc.height;

    this.ready = false;

    this.height = heightParams;
    this.heightCalc.scrollInit();
    this.widgetHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );
    this.wixBinding.updateWidgetHeight();

    if (this.wixApi.getMobileMode()) {
      this.mobile = true;
    } else {
      this.renderSchema();
    }

    if (this.wixApi.getViewMode() !== 'site') {
      this.wixBinding.addListener();
    }

    this.$rootScope.$on('new-events', () => {
      this.wixBinding.updateWidgetHeight();
    });
  }

  private renderSchema() {
    console.error('application/ld+json is disabled');
    this.schemaService.getEventsSchema().then((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.body.appendChild(script);
    });
  }
}
